import { render } from "./VerifyPage.vue?vue&type=template&id=56fe98c4"
import script from "./VerifyPage.vue?vue&type=script&lang=js"
export * from "./VerifyPage.vue?vue&type=script&lang=js"
script.render = render

export default script